import { IProductSpecification } from 'app/shared/model/product-specification.model';
import { ISupplier } from 'app/shared/model/supplier.model';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { Variant } from 'app/shared/model/enumerations/variant.model';
import { CommercialBusiness } from 'app/shared/model/enumerations/commercial-business.model';

export interface IProductOffering {
  id?: number;
  contractType?: keyof typeof ContractType | null;
  variant?: keyof typeof Variant | null;
  commercialBusiness?: keyof typeof CommercialBusiness | null;
  productSpecification?: IProductSpecification | null;
  supplier?: ISupplier | null;
}

export const defaultValue: Readonly<IProductOffering> = {};
